import React, { Component } from "react";

import Card from "../commons/Card"; 

import PageTitle from "../commons/PageTitle";
import TierSelector from "../commons/TierSelector";

const Error = ({ user, team, teams, isTeamLeadOrAbove, title, content }) => {

  const renderTierSelector = () => (
    <div className="dashboard-row selector">
      <PageTitle
        title={I18n.t("insights.page.title")}
        selectors={
          <TierSelector
            user={user}
            teams={teams}
            selectedTeam={team}
            isTeamLeadOrAbove={isTeamLeadOrAbove}
          />
        }
        showBack
      />
    </div>
  );

  return (
    <div className="wrapper">
      <div className="dashboard insights">
        <div className="container-fluid">
          {renderTierSelector()}
          <div className="page-content">
            <Card title={title} content={content} />
          </div>
        </div>
      </div>
    </div>
  );
}

// NOTE: needed now to current version of ReactOnRails to work with hooks
export default class ErrorComponent extends Component {
  render() {
    return <Error {...this.props} />;
  }
}